export const invoiceDocuments = [
  'Sales or Charge invoices',
  'Billing Statements',
  'Delivery or Counter Receipts',
  'Acknowledgement Receipts',
  'Statements of Account',
];

export const purchaseOrderDocuments = [
  'Purchase Orders',
  'Notices of Award',
  'Notices to Proceed',
  'Work or Job Orders',
];



// WEBPACK FOOTER //
// ./src/features/applyNow/misc/tradeDocumentExamples.js